import { GameCardProps } from '../components/GameCard';

export const gamesData: GameCardProps[] = [
  {
    title: 'Night Wanders',
    description: 'An atmospheric adventure where darkness reveals hidden truths. Navigate through mysterious nights filled with secrets waiting to be uncovered.',
    status: 'In Development',
    emoji: '🌙',
    gradientFrom: 'from-tal-brown-600',
    gradientTo: 'to-tal-blue-600',
    borderColor: 'border-tal-brown-500',
    link: '/projects/night-wanders',
    imageUrl: '/games/NW_header.jpg',
  },
  {
    title: 'Confused Feelings',
    description: 'A narrative-driven experience exploring the complexity of human emotions. Make choices that shape relationships and discover your path.',
    status: 'Planning',
    emoji: '💭',
    gradientFrom: 'from-tal-blue-700',
    gradientTo: 'to-tal-slate-600',
    borderColor: 'border-tal-blue-500',
    link: '/projects/confused-feelings',
    imageUrl: '/games/CF_header.jpg',
  },
  {
    title: 'Kensley',
    description: 'Embark on a journey through a dark detailed world. Build friendship, face challenges, and carve your own destiny, but all be concerned about the rain ...',
    status: 'In Discussion',
    emoji: '⚔️',
    gradientFrom: 'from-tal-brown-500',
    gradientTo: 'to-tal-brown-700',
    borderColor: 'border-tal-slate-600',
    link: '/projects/kensley',
    hideLearnMore: true,
  },
];
